import { render, staticRenderFns } from "./selectIssue.vue?vue&type=template&id=6b0aceaa&"
import script from "./selectIssue.vue?vue&type=script&lang=ts&"
export * from "./selectIssue.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports